import { FleekError } from './FleekError';

type ProjectInvalidNameErrorOptions = {
  name: string;
};

export class ProjectInvalidNameError extends FleekError<ProjectInvalidNameErrorOptions> {
  public name = 'ProjectInvalidNameError';

  toString = () => `The project name ${this.data.name} is invalid.`;
}
